import moment from 'moment';

export const formataDataMotivo = (dta_ini_contingencia: string): string => {
  const formattedDateTime = moment(dta_ini_contingencia).format(
    'YYYY-MM-DDTHH:mm:ss',
  );

  return formattedDateTime;
};
